// store/index.js
import { createStore } from 'vuex'
import apiClient from '@/api'

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      } else {
        localStorage.removeItem('user')
      }
    },
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    LOGOUT(state) {
      state.user = null
      state.token = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },

  actions: {
    async checkAuth({ commit, state }) {
      if (!state.token) {
        return false
      }

      try {
        commit('SET_LOADING', true)
        const response = await apiClient.get('auth/verify')

        if (response && response.user) {
          commit('SET_USER', response.user)
        }

        return true
      } catch (error) {
        console.error('Auth check failed:', error)

        if (error.status === 401) {
          commit('LOGOUT')
        }

        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async login({ commit }, credentials) {
      try {
        commit('SET_LOADING', true)
        const { token, user } = await apiClient.login(credentials)

        commit('SET_TOKEN', token)
        commit('SET_USER', user)
        commit('SET_ERROR', null)

        return true
      } catch (error) {
        commit('SET_ERROR', error.message || 'Login failed')
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },

    logout({ commit }) {
      // Don't wait for API response
      apiClient.logout().catch(error => {
        console.error('Logout API error:', error)
      })

      // Immediately clear the state
      commit('LOGOUT')

      return true
    },

    async fetchData({ commit }, { endpoint, params = {}, method = 'GET' }) {
      try {
        commit('SET_LOADING', true)
        const data = await apiClient.fetch(endpoint, params, { method })
        commit('SET_ERROR', null)
        return data
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to fetch data')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },

  getters: {
    isAuthenticated: state => !!state.token,
    user: state => state.user,
    // Berechtigungen kommen als Fähigkeits-Map vom Backend (User#abilities) —
    // EINZIGE Quelle der Wahrheit. Komponenten fragen `can('...')`, nie die Rolle.
    abilities: state => (state.user && state.user.abilities) || {},
    can: (state, getters) => capability => !!getters.abilities[capability],
    loading: state => state.loading,
    error: state => state.error
  }
})